import React, { useState } from "react";
import { Bell, Check, Loader2 } from "lucide-react";
import http from "@/api";
import { useApp } from "@/context";

/* 🔔 «أبلغني عند توفره» — للمنتجات الموقوفة مؤقتاً */
export default function NotifyMe({ productId, size = "lg" }) {
  const { lang, user } = useApp();
  const ar = lang !== "en";
  const [phone, setPhone] = useState("");
  const [askPhone, setAskPhone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const subscribe = async (ph = "") => {
    setBusy(true);
    try {
      await http.post(`/products/${productId}/notify-me`, { phone: ph });
      setDone(true);
      setAskPhone(false);
    } catch (e) {
      const d = e?.response?.data?.detail;
      if (e?.response?.status === 400 && !user) setAskPhone(true);
      else alert(typeof d === "string" ? d : (ar ? "تعذر التسجيل" : "Failed"));
    } finally {
      setBusy(false);
    }
  };

  const start = () => {
    if (user?.phone || user) subscribe("");
    else setAskPhone(true);
  };

  if (done) {
    return (
      <div className={`flex items-center justify-center gap-2 rounded-2xl font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 ${size === "lg" ? "py-3 px-4 w-full" : "py-1.5 px-3 text-xs"}`}
           data-testid="notify-me-done">
        <Check size={16} /> {ar ? "سنبلغك فور توفره 🌹" : "We'll notify you when it's back 🌹"}
      </div>
    );
  }

  if (askPhone) {
    return (
      <div className="flex gap-2 w-full" data-testid="notify-me-phone-form">
        <input dir="ltr" inputMode="tel" className="input-field flex-1 !py-2.5 !text-sm"
               placeholder={ar ? "رقم واتساب مثال: 55501234" : "WhatsApp number"}
               value={phone} onChange={(e) => setPhone(e.target.value)}
               data-testid="notify-me-phone-input" />
        <button onClick={() => phone.trim() && subscribe(phone.trim())} disabled={busy || !phone.trim()}
                className="btn-primary !py-2.5 !px-4 !text-sm" data-testid="notify-me-phone-submit">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Bell size={15} />}
        </button>
      </div>
    );
  }

  return (
    <button onClick={start} disabled={busy}
            className={size === "lg" ? "btn-primary w-full !py-3" : "chip !text-xs"}
            data-testid="notify-me-btn">
      {busy ? <Loader2 size={16} className="animate-spin" /> : <Bell size={16} />}
      {ar ? "🔔 أبلغني عند توفره" : "🔔 Notify me when available"}
    </button>
  );
}
